import React, { useEffect } from 'react';
import { UserInfoState } from 'stores/userInfo';
import { track } from 'telemetry';
import { ETelemetryActionsAndLabels, ETelemetryNames } from 'telemetry/type';
import upperFirst from 'lodash/upperFirst';
import { useSelector } from 'react-redux';
import { RootState } from 'stores';
import { BaseTemplate } from '@myob/myob-widgets';
import { ErrorComponent } from 'pages/ErrorPages';
import { EHttpStatusCode } from 'helpers/type';

export type Props = {};

export const AppErrorWrapper: React.FC<Props> = ({ children }) => {
    const { error, isError } = useSelector<RootState, UserInfoState>(state => state.userInfo);

    useEffect(() => {
        if (isError) {
            track(ETelemetryNames.ErrorPage, {
                action: ETelemetryActionsAndLabels.View,
                label: ETelemetryActionsAndLabels.View,
                viewData: {
                    reason: error?.message,
                    comeFrom: upperFirst(window.location.pathname.slice(1)),
                },
            });
        }
    }, [error, isError]);

    const isNotUnauthorizedError = isError && error?.status !== EHttpStatusCode.FORBIDDEN;

    return (
        <>
            {isNotUnauthorizedError ? (
                <BaseTemplate>
                    <ErrorComponent parentPage="userInfo" />
                </BaseTemplate>
            ) : (
                children
            )}
        </>
    );
};

export default AppErrorWrapper;
